const POLL_MS = 5 * 60 * 1000; // poll every 5 minutes for deploys while page stays open

// Version baked into the JS bundle at build time by prebuild.js → .env.local
const BUNDLE_VERSION = process.env.REACT_APP_BUILD_VERSION || null;

let _initialV = null;
let _timer    = null;
let _onUpdate = null;

async function fetchVersion() {
  // Cache-bust so the service worker doesn't serve a stale response
  const r = await fetch(`/version.json?_=${Date.now()}`, { cache: 'no-store' });
  if (!r.ok) throw new Error('fetch failed');
  return r.json();
}

export async function initVersionChecker(onUpdate) {
  _onUpdate = onUpdate;
  try {
    const data = await fetchVersion();
    _initialV = data.v;
    window.__appBuildInfo = data;

    // If the server's version differs from what's running in this bundle,
    // a newer deploy is already live — show the banner immediately on load.
    if (BUNDLE_VERSION && data.v && data.v !== BUNDLE_VERSION) {
      onUpdate(data);
      return; // no need to poll — update already flagged
    }
  } catch {
    return; // version.json missing (local dev without prebuild) — skip silently
  }

  // Also poll while the page is open, to catch deploys that happen mid-session
  _timer = setInterval(async () => {
    try {
      const data = await fetchVersion();
      if (data.v && data.v !== _initialV) {
        clearInterval(_timer);
        _onUpdate?.(data);
      }
    } catch {}
  }, POLL_MS);
}

export function stopVersionChecker() {
  if (_timer) { clearInterval(_timer); _timer = null; }
}

export function getBuildInfo() {
  return window.__appBuildInfo || null;
}
